'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import SVGTextStyle from './SVGTextStyle';
import SVGWrapper from './SVGWrapper';

const SVGText = props => {
  const {
    wrapperProps
  } = props,
        innerProps = _objectWithoutPropertiesLoose(props, ["wrapperProps"]);

  return /*#__PURE__*/_jsx(SVGWrapper, Object.assign({}, wrapperProps, {
    children: /*#__PURE__*/_jsx(SVGTextStyle, Object.assign({}, innerProps))
  }));
};

SVGText.propTypes = {
  wrapperProps: PropTypes.any
};
export default SVGText;